import { Button } from '../button/button';
import { WorkspaceUsersProps } from './types';
import { supabase } from '../../../lib/supabase';
import { Pill } from '../../pill/pill';
import { Trash } from 'lucide-react';

export function WorkspaceUsers({
  authUser,
  users,
  setUsers,
  toggleUserAdmin,
}: WorkspaceUsersProps) {
  const removeUser = async ({
    userId,
    email,
  }: {
    userId: string;
    email: string;
  }) => {
    if (!userId || !email) return;
    try {
      const { error: workspaceProfileError } = await supabase
        .from('workspace_profiles')
        .delete()
        .eq('profile_id', userId)
        .eq('workspace_id', authUser?.currentWorkspace?.workspace_id);

      if (workspaceProfileError) {
        throw workspaceProfileError;
      }

      const { error: workspaceInvitationError } = await supabase
        .from('workspace_invitations')
        .delete()
        .eq('workspace_id', authUser?.currentWorkspace?.workspace_id)
        .eq('invited_email', email);

      if (workspaceInvitationError) {
        throw workspaceInvitationError;
      }
      setUsers((prev) => prev?.filter((user) => user.id !== userId) || null);
    } catch (err) {
      console.error('Error removing user:', err);
    }
  };

  const isAdmin = authUser?.currentWorkspace?.role?.name === 'admin';

  return (
    <div className="flex flex-col gap-2">
      {!!users?.length && (
        <div className="flex flex-col gap-2">
          {users?.map((user) => (
            <div
              key={user?.id}
              className="flex items-center justify-between rounded-lg bg-prompt-safecomwhite p-3"
            >
              <div>
                <div className="flex items-center gap-2">
                  <p className="font-medium">{user.email}</p>
                  {user.id ===
                    authUser?.currentWorkspace?.workspaces?.created_by && (
                    <Pill text="Owner" variant="primary" />
                  )}
                  {user.id === authUser?.id && (
                    <Pill text="You" variant="info" />
                  )}
                </div>
                <p className="text-sm text-prompt-safecomabbey">
                  {user.role === 'admin' ? 'Admin' : 'Viewer'}
                </p>
              </div>
              {isAdmin &&
                authUser?.id !== user.id &&
                user.id !==
                  authUser?.currentWorkspace?.workspaces?.created_by && (
                  <div className="flex items-center gap-2">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() =>
                        toggleUserAdmin(user.id, user.role !== 'admin')
                      }
                    >
                      {user.role === 'admin' ? 'Remove admin' : 'Make admin'}
                    </Button>
                    <Button
                      variant="outline"
                      className="text-red-600 hover:text-red-700"
                      size="sm"
                      onClick={() =>
                        removeUser({ userId: user?.id, email: user?.email })
                      }
                    >
                      <Trash />
                    </Button>
                  </div>
                )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
